module.exports = __webpack_public_path__ + "static/media/abouttop1.1bf453b0.png";